import * as React from "react";
import { connect } from "react-redux";

import * as actions from "../../actions";
import {
  BirthdayInput as BirthdayInputComponent,
  BirthdayInputProps as BirthdayInputComponentProps,
} from "../../components/BirthdayInput/BirthdayInput";
import { StoreState } from "../../reducers";
import { getWidgetFormErrors } from "../../reducers/methods";

interface BirthdayInputProps extends BirthdayInputComponentProps {
  clearWidgetFormError: typeof actions.clearWidgetFormError;
  formErrors: {
    [key: string]: { [index: string]: any };
  };
  setWidgetFormError: typeof actions.setWidgetFormError;
  setUserInput: typeof actions.setUserInput;
}

class BirthdayInput extends React.Component<BirthdayInputProps> {
  render() {
    const { setWidgetFormError, setUserInput } = this.props;

    return (
      <BirthdayInputComponent
        {...this.props}
        onFormError={setWidgetFormError}
        onFormChange={setUserInput}
      />
    );
  }
}

const mapStateToProps = (state: StoreState) => ({
  formErrors: getWidgetFormErrors(state),
});

export default connect(mapStateToProps, {
  clearWidgetFormError: actions.clearWidgetFormError,
  setWidgetFormError: actions.setWidgetFormError,
  setUserInput: actions.setUserInput,
})(BirthdayInput);
